import { useState } from "react";
import "./Clientdetailpage.css";
import { transformClients } from "../../pages/Clients";

/* ── mock data matching the schema ─────────────────────── */
const MOCK_CLIENT = {
  _id: "c001",
  clientName: "Mama Eya",
  clientEmail: "mamaeya@example.com",
  clientPhoneNumber: "91447264",
  shopAddress: "Emma gads vej 42",
  shopLocation: "Gboko – Benue State",
  businessCategory: "Food & Beverages",
  isClientInterestedInSoftware: true,
  isClientInterestedInHardware: false,
  isFollowUpNeeded: true,
  didClientRequestADemo: true,
  contactDate: "2024-11-10T00:00:00.000Z",
  conversionDate: "2025-01-15T00:00:00.000Z",
  POScontract: "leased",
  contractPdfLink: null,
  shopImage: null,
  pendingPaymentAmount: 12500,
  visits: 1,
  lastVisitDate: "2025-03-20T00:00:00.000Z",
  followUpDate: "2025-06-01T00:00:00.000Z",
  notes: "Client is interested in upgrading to premium plan. Follow up after June.",
  status: "converted",
  generatedRevenueForAgent: 45000,
  webstoreUserID: "u001",
};

const MOCK_WEBSTORE_USER = {
  fullName: "Mama Eya",
  email: "mamaeya@example.com",
  phoneNumber: "91447264",
  userIsSubscribed: true,
  subscriptionStatus: "active",
  userType: {
    userType: "Premium",
    subcriptionDate: "2025-01-15T00:00:00.000Z",
    subcriptionEndDate: "2025-07-15T00:00:00.000Z",
    subscriptionAmount: 15000,
  },
  maxStore: 5,
  maxWarehouse: 3,
  maxProduct: 500,
  store: [{ storeName: "Mama Eya Foods" }],
  warehouse: [],
  isProfileComplete: true,
  isEmailVerified: true,
  createdProdcutsCount: 34,
  onlinecustomers: 12,
  offlineCustomers: 28,
};

/* ── helpers ────────────────────────────────────────────── */
function fmt(dateStr) {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("en-NG", { day: "numeric", month: "short", year: "numeric" });
}

function daysUntil(dateStr) {
  if (!dateStr) return null;
  return Math.ceil((new Date(dateStr) - new Date()) / (1000 * 60 * 60 * 24));
}

function StatusBadge({ status }) {
  const map = {
    converted: "cdp__badge--green",
    active: "cdp__badge--blue",
    lead: "cdp__badge--purple",
    new: "cdp__badge--gray",
    "not interested": "cdp__badge--red",
  };
  return <span className={`cdp__badge ${map[status] || "cdp__badge--gray"}`}>{status}</span>;
}

function ContractBadge({ val }) {
  const map = { leased: "cdp__badge--amber", purchased: "cdp__badge--green", installment: "cdp__badge--purple", none: "cdp__badge--gray" };
  return <span className={`cdp__badge ${map[val] || "cdp__badge--gray"}`}>{val}</span>;
}

const packageInfo = [
  {
    label: "Basic – ₦3,500/mo",
    value: "basic",
    price: 3500,
  },
  {
    label: "Super user – ₦9,500/mo",
    value: "super_user",
    price: 9500,
  },
  {
    label: "Premium – ₦22,500/mo",
    value: "premium",
    price: 22500,
  },
  {
    label: "Enterprise – ₦31,900/mo",
    value: "enterprise",
    price: 31900,
  },
];
const spinnerSVG = (
  <svg style={{ animation: "spin .7s linear infinite", transformOrigin: "center" }} width='16' height='16' viewBox='0 0 16 16' fill='none'>
    <circle cx='8' cy='8' r='6' stroke='rgba(255,255,255,.3)' strokeWidth='2' />
    <path d='M14 8A6 6 0 0 0 8 2' stroke='#fff' strokeWidth='2' strokeLinecap='round' />
  </svg>
);

/* ── Subscribe modal ────────────────────────────────────── */
function SubscribeModal({ onClose, webstoreUserEmail, setClients, setSelectedWebstoreUser }) {
  const [plan, setPlan] = useState("");
  const [duration, setDuration] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const plans = [
    {
      label: "Basic – ₦3,500/mo",
      value: "basic",
      price: 3500,
    },
    {
      label: "Super user – ₦9,500/mo",
      value: "super",
      price: 9500,
    },
    {
      label: "Premium – ₦22,500/mo",
      value: "premium",
      price: 22500,
    },
    {
      label: "Enterprise – ₦31,900/mo",
      value: "enterprise",
      price: 31900,
    },
  ];

  const subscribedUser = async () => {
    if (!webstoreUserEmail) {
      alert("User not found. Client must have a StoreLense account to subscribe them to a plan");
      return;
    }

    try {
      setIsSubmitting(true);
      if (!plan) return alert("Please select a plan to subscribe the user");
      if (!webstoreUserEmail) return alert("User email not found. Cannot subscribe user without email.");

      const agentData = localStorage.getItem("agentData");
      if (!agentData.hasAdminPrivileges) {
        alert("You do not have permission to subscribe users to plans. Please contact your administrator.");
        return;
      }

      if (
        !window.confirm(
          `Confirm subscribing user to the ${plans.find((p) => p.value === plan).label} for ${duration} month(s) at a total price of ₦${(
            plans.find((p) => p.value === plan).price * duration
          ).toLocaleString()}?`
        )
      ) {
        return;
      }

      // TODO: call API to subscribe user to plan

      const subscriptionData = {
        packageName: plan,
        duration: duration === 1 ? "Monthly" : duration === 3 ? "Quarterly" : duration === 6 ? "Semi-Annual" : "Yearly",
        amountPaid: Number(plans.find((p) => p.value === plan).price) * Number(duration),
        email: webstoreUserEmail,
        custom: false,
      };

      const agentID = JSON.parse(agentData)._id;

      let url = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/subscribeUser/" + agentID;

      let response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ subscriptionData }),
      });
      let result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to subscribe user");
      }
      alert("User subscribed successfully!");
      // Update the client's subscription status in the UI

      setSelectedWebstoreUser(result.user);
      const transformedClients = transformClients(result.updatedMarketingAgent.clients);
      setClients(transformedClients);
      onClose();
      localStorage.setItem("agentData", JSON.stringify(result.updatedMarketingAgent));
    } catch (error) {
      console.error("Error subscribing user:", error);
      alert(error.message || "An error occurred while subscribing the user. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='cdp__modal-backdrop' onClick={onClose}>
      <div className='cdp__modal' onClick={(e) => e.stopPropagation()}>
        <div className='cdp__modal-header'>
          <span className='cdp__modal-title'>Subscribe User</span>
          <button className='cdp__modal-close' onClick={onClose}>
            ✕
          </button>
        </div>
        <div className='cdp__modal-body'>
          <div className='cdp__form-group'>
            <label className='cdp__form-label'>Plan / User Type</label>
            <select className='cdp__select' value={plan} onChange={(e) => setPlan(e.target.value)}>
              <option value='' disabled hidden>
                Choose plan
              </option>
              {plans.map((p) => (
                <option key={p.value} value={p.value}>
                  {p.label}
                </option>
              ))}
            </select>
          </div>
          <div className='cdp__form-group'>
            <label className='cdp__form-label'>Duration (months)</label>
            <select className='cdp__select' value={duration} onChange={(e) => setDuration(e.target.value)}>
              {[1, 3, 6, 12, 24].map((m) => (
                <option key={m} value={m}>
                  {m} month{m > 1 ? "s" : ""}
                </option>
              ))}
            </select>
          </div>
          {plan && (
            <div className='cdp__summary-box'>
              <span>Plan</span>
              <strong>{plan}</strong>
              <span>Duration</span>
              <strong>
                {duration} month{duration > 1 ? "s" : ""}
              </strong>
              <span>Total price</span>
              <strong>
                ₦{(plans.find((p) => p.value === plan).price * duration.toString())?.toLocaleString()} (₦
                {plans.find((p) => p.value === plan).price?.toLocaleString()} x {duration})
              </strong>
            </div>
          )}
        </div>
        <div className='cdp__modal-footer'>
          <button className='cdp__btn-outline' onClick={onClose}>
            Cancel
          </button>
          <button onClick={subscribedUser} className='cdp__btn-primary' disabled={!plan || isSubmitting}>
            {isSubmitting ? spinnerSVG : "Confirm Subscription"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Upload modal ───────────────────────────────────────── */
function UploadModal({ onClose, webstoreUserID, setClients, setSelectedWebstoreUser }) {
  const [files, setFiles] = useState({ contract: null, shopImage: null, bizReg: null });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFile = (key) => (e) => setFiles((f) => ({ ...f, [key]: e.target.files[0] }));
  const items = [
    { key: "contract", label: "Lease / Purchase Contract", icon: "📄" },
    { key: "shopImage", label: "Shop Image", icon: "🏪" },
    { key: "bizReg", label: "Business Registration", icon: "📋" },
  ];

  const uploadBusinessFiles = async () => {
    try {
      setIsSubmitting(true);
      const hasAtLeastOneFile = Object.values(files).some(Boolean);

      if (!hasAtLeastOneFile) {
        alert("Please select at least one file");
        return;
      }

      const formData = new FormData();

      if (files.contract) {
        formData.append("contract", files.contract);
      }

      if (files.shopImage) {
        formData.append("shopImage", files.shopImage);
      }

      if (files.bizReg) {
        formData.append("bizReg", files.bizReg);
      }

      const agentData = localStorage.getItem("agentData");
      if (!agentData) {
        return;
      }
      const agentID = JSON.parse(agentData)._id;
      let url = `${process.env.REACT_APP_Back_end_api_root}/marketingAgentApp/uploadClientFile/${webstoreUserID}/${agentID}`;

      const response = await fetch(url, {
        method: "PATCH",
        body: formData,
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Upload failed");
      }

      // set agent data
      localStorage.setItem("agentData", JSON.stringify(result.updatedMarketingAgent));

      const transformedClients = transformClients(result.updatedMarketingAgent.clients);
      const selectedUser = result.updatedUser;

      setClients(transformedClients);
      setSelectedWebstoreUser(selectedUser);
      onClose();
      alert("Files uploaded successfully");
    } catch (error) {
      console.error(error);
      alert(error.message || "Error uploading files");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='cdp__modal-backdrop' onClick={onClose}>
      <div className='cdp__modal' onClick={(e) => e.stopPropagation()}>
        <div className='cdp__modal-header'>
          <span className='cdp__modal-title'>Upload Documents</span>
          <button className='cdp__modal-close' onClick={onClose}>
            ✕
          </button>
        </div>
        <div className='cdp__modal-body'>
          {items.map((item) => (
            <div className='cdp__upload-row' key={item.key}>
              <span className='cdp__upload-icon'>{item.icon}</span>
              <div className='cdp__upload-info'>
                <span className='cdp__upload-label'>{item.label}</span>
                {files[item.key] && <span className='cdp__upload-filename'>{files[item.key].name}</span>}
              </div>
              <label className='cdp__btn-upload-sm'>
                {files[item.key] ? "Change" : "Upload"}
                <input type='file' hidden onChange={handleFile(item.key)} />
              </label>
            </div>
          ))}
        </div>
        <div className='cdp__modal-footer'>
          <button className='cdp__btn-outline' onClick={onClose}>
            Cancel
          </button>
          <button disabled={isSubmitting} onClick={uploadBusinessFiles} className='cdp__btn-primary'>
            {isSubmitting ? spinnerSVG : "Save Documents"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Main page ──────────────────────────────────────────── */
export default function ClientDetailPage({ client = MOCK_CLIENT, webstoreUser = MOCK_WEBSTORE_USER, onBack, setClients, setSelectedWebstoreUser }) {
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const daysLeft = webstoreUser ? daysUntil(webstoreUser.userType?.subcriptionEndDate) : null;
  const subExpiringSoon = daysLeft !== null && daysLeft <= 31 && daysLeft > 0;
  const subExpired = daysLeft !== null && daysLeft <= 0;

  console.log(webstoreUser);

  return (
    <div className='cdp__page'>
      {/* ── Top nav bar ── */}
      <div className='cdp__topbar'>
        <button className='cdp__back-btn' onClick={onBack}>
          <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5'>
            <path d='M19 12H5' />
            <path d='M12 5l-7 7 7 7' />
          </svg>
          Clients
        </button>
        <div className='cdp__topbar-actions'>{client?.followUpRequired && <span className='cdp__badge cdp__badge--amber'>⚠ Follow-up</span>}</div>
      </div>

      {/* ── Hero ── */}
      <div className='cdp__hero'>
        <div className='cdp__avatar'>
          {client?.shopImage || webstoreUser?.businessInfo?.shopImage ? (
            <img src={client.shopImage || webstoreUser.businessInfo.shopImage} alt={client?.name} />
          ) : (
            <span>{client?.name.slice(0, 2).toUpperCase()}</span>
          )}
        </div>
        <div className='cdp__hero-info'>
          <h1 className='cdp__hero-name'>{client.name}</h1>
          <span className='cdp__hero-category'>{client.businessCategories}</span>
          <div className='cdp__hero-contact'>
            <span>📞 {client.phone}</span>
            {client.clientEmail && <span>✉ {client.clientEmail}</span>}
            <span>
              📍 {client?.shopAddress}
              {client?.shopLocation ? `, ${client?.shopLocation}` : ""}
            </span>
          </div>
        </div>
        <div className='cdp__hero-badges'>
          <StatusBadge status={client.status} />
          <ContractBadge val={client.POScontract} />
        </div>
      </div>

      {/* ── Subscription expiry warning ── */}
      {(subExpiringSoon || subExpired) && (
        <div className={`cdp__sub-warning ${subExpired ? "cdp__sub-warning--expired" : "cdp__sub-warning--soon"}`}>
          <span className='cdp__sub-warning-icon'>{subExpired ? "🔴" : "🟠"}</span>
          <span>
            {subExpired
              ? "Subscription has expired. Renew now to avoid service interruption."
              : `Subscription expires in ${daysLeft} day${daysLeft !== 1 ? "s" : ""} — renew soon.`}
          </span>
        </div>
      )}

      <div className='cdp__grid'>
        {/* ── Left column ── */}
        <div className='cdp__col'>
          {/* Stats strip */}
          <div className='cdp__stats-strip'>
            <div className='cdp__stat'>
              <span className='cdp__stat-val'>{client.visits}</span>
              <span className='cdp__stat-lbl'>Visits</span>
            </div>
            <div className='cdp__stat-div' />
            <div className='cdp__stat'>
              <span className='cdp__stat-val'>₦{client.generatedRevenueForAgent?.toLocaleString()}</span>
              <span className='cdp__stat-lbl'>Revenue Generated</span>
            </div>
            <div className='cdp__stat-div' />
            <div className='cdp__stat'>
              <span className='cdp__stat-val'>₦{client.pendingPaymentAmount?.toLocaleString()}</span>
              <span className='cdp__stat-lbl'>Pending Payment</span>
            </div>
          </div>

          {/* Client info card */}
          <div className='cdp__card'>
            <div className='cdp__card-title'>Client Details</div>
            <div className='cdp__info-grid'>
              <span className='cdp__info-key'>Contact Date</span>
              <span className='cdp__info-val'>{fmt(client.contactDate)}</span>
              <span className='cdp__info-key'>Conversion Date</span>
              <span className='cdp__info-val'>{fmt(client.conversionDate)}</span>
              <span className='cdp__info-key'>Last Visit</span>
              <span className='cdp__info-val'>{fmt(client.lastVisitDate)}</span>
              <span className='cdp__info-key'>Follow-up Date</span>
              <span className='cdp__info-val'>{fmt(client.followUpDate)}</span>
              <span className='cdp__info-key'>POS Contract</span>
              <span className='cdp__info-val'>
                <ContractBadge val={client.POScontract} />
              </span>
              <span className='cdp__info-key'>Interested In</span>
              <span className='cdp__info-val cdp__interest-tags'>
                {client.isClientInterestedInSoftware && <span className='cdp__tag'>Software</span>}
                {client.isClientInterestedInHardware && <span className='cdp__tag'>Hardware</span>}
                {!client.isClientInterestedInSoftware && !client.isClientInterestedInHardware && "—"}
              </span>
              <span className='cdp__info-key'>Demo Requested</span>
              <span className='cdp__info-val'>{client.didClientRequestADemo ? "✅ Yes" : "No"}</span>
            </div>
          </div>

          {/* Notes */}
          {client.notes && (
            <div className='cdp__card'>
              <div className='cdp__card-title'>Notes</div>
              <p className='cdp__notes-text'>{client.notes}</p>
            </div>
          )}

          {/* Contract PDF link */}
          {client.contractPdfLink && (
            <a href={client.contractPdfLink} target='_blank' rel='noreferrer' className='cdp__pdf-link'>
              📄 View Contract PDF
            </a>
          )}
        </div>

        {/* ── Right column ── */}
        <div className='cdp__col'>
          {/* Webstore user info */}
          {webstoreUser ? (
            <div className='cdp__card cdp__card--accent'>
              <div className='cdp__card-title'>
                StoreLense Account
                <span className={`cdp__badge ${webstoreUser.subscriptionStatus === "active" ? "cdp__badge--green" : "cdp__badge--red"}`}>
                  {webstoreUser.subscriptionStatus}
                </span>
              </div>

              {webstoreUser.userIsSubscribed ? (
                <div className='cdp__sub-plan-box'>
                  <div className='cdp__sub-plan-name'>{webstoreUser.userType?.userType || "—"} Plan</div>
                  <div className='cdp__sub-plan-amount'>
                    ₦{webstoreUser.userType?.subscriptionAmount?.toLocaleString() ?? "—"}
                    <span>/mo</span>
                  </div>
                  <div className='cdp__sub-plan-dates'>
                    <span>From {fmt(webstoreUser.userType?.subcriptionDate)}</span>
                    <span className={subExpired ? "cdp__date--red" : subExpiringSoon ? "cdp__date--amber" : ""}>
                      Expires {fmt(webstoreUser.userType?.subcriptionEndDate)}
                      {(subExpiringSoon || subExpired) && ` · ${subExpired ? "expired" : `${daysLeft}d left`}`}
                    </span>
                  </div>
                </div>
              ) : (
                <div className='cdp__sub-plan-box'>
                  <div className='cdp__sub-plan-name'>No active subscription</div>
                </div>
              )}

              <div className='cdp__info-grid cdp__info-grid--tight'>
                <span className='cdp__info-key'>Max Stores</span>
                <span className='cdp__info-val'>{webstoreUser.maxStore}</span>
                <span className='cdp__info-key'>Max Warehouses</span>
                <span className='cdp__info-val'>{webstoreUser.maxWarehouse}</span>
                <span className='cdp__info-key'>Max Products</span>
                <span className='cdp__info-val'>{webstoreUser.maxProduct}</span>
                <span className='cdp__info-key'>Products Created</span>
                <span className='cdp__info-val'>{webstoreUser.createdProdcutsCount}</span>
                <span className='cdp__info-key'>Online Customers</span>
                <span className='cdp__info-val'>{webstoreUser.onlinecustomers}</span>
                <span className='cdp__info-key'>Offline Customers</span>
                <span className='cdp__info-val'>{webstoreUser.offlineCustomers}</span>
                <span className='cdp__info-key'>Email Verified</span>
                <span className='cdp__info-val'>{webstoreUser.isEmailVerified ? "✅ Yes" : "❌ No"}</span>
                <span className='cdp__info-key'>Profile Complete</span>
                <span className='cdp__info-val'>{webstoreUser.isProfileComplete ? "✅ Yes" : "❌ No"}</span>
              </div>

              {webstoreUser.store?.length > 0 && (
                <div className='cdp__stores-list'>
                  <span className='cdp__info-key'>Stores</span>
                  <div className='cdp__store-tags'>
                    {webstoreUser.store.map((s, i) => (
                      <span key={i} className='cdp__tag cdp__tag--store'>
                        🏬 {s.storeName}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className='cdp__card cdp__card--muted'>
              <div className='cdp__card-title'>StoreLense Account</div>
              <p className='cdp__muted-text'>This client has not signed up on StoreLense yet.</p>
              <button
                onClick={() => {
                  const storedAgent = localStorage.getItem("agentData");

                  if (!storedAgent) {
                    return;
                  }
                  const agentLink = `${JSON.parse(storedAgent).referralLink}&client=${client.id}`;

                  window.open(agentLink, "_blank");
                }}
                className='cdp__btn-primary cdp__btn-full'
              >
                Sign Client Up →
              </button>
            </div>
          )}

          {/* CTA buttons */}
          <div className='cdp__cta-stack'>
            <button className='cdp__btn-primary cdp__btn-full' onClick={() => setShowSubscribeModal(true)}>
              💳 Subscribe User
            </button>
            <button
              onClick={() => {
                if (!webstoreUser) return alert("Client must have a StoreLense account to send them a payment link");
              }}
              className='cdp__btn-outline cdp__btn-full'
            >
              🔗 Send Payment Link
            </button>
            <button
              className='cdp__btn-outline cdp__btn-full'
              onClick={() => {
                if (!webstoreUser) return alert("Client must have a StoreLense account to upload documents");

                setShowUploadModal(true);
              }}
            >
              📁 Upload Documents
            </button>
          </div>
        </div>
      </div>

      {showSubscribeModal && (
        <SubscribeModal
          onClose={() => setShowSubscribeModal(false)}
          webstoreUserEmail={webstoreUser?.email}
          setClients={setClients}
          setSelectedWebstoreUser={setSelectedWebstoreUser}
        />
      )}
      {showUploadModal && (
        <UploadModal
          onClose={() => setShowUploadModal(false)}
          webstoreUserID={webstoreUser._id}
          setClients={setClients}
          setSelectedWebstoreUser={setSelectedWebstoreUser}
        />
      )}
    </div>
  );
}
